import * as types from './action-types';
import services from '../../../../../../services';

const { CoreAPI } = services;

const fetchDisclosures = (type) => {
    return (dispatch) => {
        dispatch({ type: types.FETCH_DISCLOSURES });

        const api = new CoreAPI();
        const body = { requiredFor: type };
        return api.fetchDisclosures(body)
            .then((disclosures) => {
                dispatch({
                    type: types.FETCH_DISCLOSURES_SUCCESS,
                    payload: disclosures
                });
            })
            .catch((error) => {
                dispatch({
                    type: types.FETCH_DISCLOSURES_FAILURE,
                    error
                });
            });
    };
};

export default {
    fetchDisclosures
};
